import { TitleTile } from "../../../shared/data/title-tile";
import { PageFooterButton, PageFooterData } from "../../../shared/ui/page-footer/page-footer.component";
import { Stats } from "../../../shared/ui/stats/stats.component";
import { SwiperData, SwiperTile } from "../../../shared/ui/swiper/swiper.component";
import { MetricTile, Section } from "../../../shared/ui/tiles/metric-tile/metric-tile.component";
import { VideoTile } from "../../../shared/ui/tiles/video-tile/video-tile.component";

export const marsTitleTileData: TitleTile = {
  header: "Mars & Beyond",
  subHeader: "THE ROAD TO MAKING HUMANITY MULTIPLANETARY",
  imageUrl: "assets/images/human-spaceflight/mars/mars_hero_d.jpg",
  mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_hero_m.jpg",
} as TitleTile;

export const cityOnMarsTileData = {
  header: "A City on Mars",
  tilePosition: "inner-right-top",
  sections: [
    {
      description: `Establishing a self-sufficient city on Mars will require upwards of one million people
      and millions of tonnes of cargo to be delivered to the Red planet. By launching more than
      10 times per day to maximize transfer windows that open up every approximately 26 months,
      several thousand Starships will ultimately transfer crew and equipment to build a lasting
      presence on another world.`,
      imageUrl: "assets/images/human-spaceflight/mars/mars_carousel2_card1_d.jpg",
      mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_carousel2_card1_m.jpg",
      mobileImageHeight: "600px",
    } as Section,
  ],
} as MetricTile;

export const whyMarsData = {
  header: "Why Mars?",
  tilePosition: "inner-right-top",
  sections: [
    {
      description: `At an average distance of 140 million miles, Mars is one of Earth's closest habitable neighbors. Mars is about half again as far from the Sun as Earth is, so it still has decent sunlight. It is a little cold, but we can warm it up. Its atmosphere is primarily CO2 with some nitrogen and argon and a few other trace elements, which means that we can grow plants on Mars just by compressing the atmosphere. Gravity on Mars is about 38% of that of Earth, so you would be able to lift heavy things and bound around. Furthermore, the day is remarkably close to that of Earth.`,
      metrics: [
        { label: "Diameter", value: "6,791 km", secondValue: "/ 4,220 mi" },
        { label: "Day Length", value: "24 hrs 40 min" },
        { label: "Force of Gravity", value: "38% of Earth" },
        { label: "Avg Distance from Earth", value: "225Mkm", secondValue: "/ 140Mmi" },
        { label: "Age", value: "4.5 billion years" },
      ],
      imageUrl: "assets/images/human-spaceflight/mars/mars_whymars_d.jpg",
      mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_whymars_m.jpg",
    } as Section,
  ],
} as MetricTile;

export const marsStats: Stats = {
  stat1: { label: "Months to get to Mars", value: 6 },
  stat2: { label: "Moons", value: 2 },
  stat3: { label: "Orbiting Satellites", value: 14 },
} as Stats;

export const firstHumansSwiperData: SwiperData = {
  swiperAriaLabel: "First Humans On Mars carousel",
  centered: true,
  tiles: [
    {
      type: "metrics",
      tile: {
        tilePosition: "inner-left-bottom",
        header: "First Humans On Mars",
        sections: [
          {
            imageUrl: "assets/images/human-spaceflight/mars/mars_carousel1_card2_d.jpg",
            mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_carousel1_card2_m.jpg",
            description: `The first human explorers to visit Mars will lay the groundwork for permanent presence on the surface. Their mission objectives will include surveying local resources, preparing landing surfaces, setting up power generation, and building habitats.`,
          } as Section,
        ],
      } as MetricTile,
    } as SwiperTile,
    {
      type: "metrics",
      tile: {
        tilePosition: "inner-center",
        sections: [
          {
            imageUrl: "assets/images/human-spaceflight/mars/mars_carousel2_card5_d.jpg",
            mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_carousel2_card5_m.jpg",
            description: `“You want to wake up in the morning and think the future is going to be great - and that’s what being a spacefaring civilization is all about. It’s about believing in the future and thinking that the future will be better than the past. And I can’t think of anything more exciting than going out there and being among the stars.”`,
            secondDescription: `-Elon Musk`,
          } as Section,
        ],
      } as MetricTile,
    } as SwiperTile,
  ],
} as SwiperData;

export const cityOnMarsSwiperData: SwiperData = {
  swiperAriaLabel: "First Humans On Mars carousel",
  centered: true,
  tiles: [
    {
      type: "metrics",
      tile: {
        tilePosition: "inner-left-top",
        header: "Building a city",
        sections: [
          {
            imageUrl: "assets/images/human-spaceflight/mars/mars_carousel2_card2_d.jpg",
            mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_carousel2_card2_m.jpg",
            description: `Key technologies are required to establish a permanent home on Mars and provide opportunities for those on Earth to take part in making life multiplanetary. New industries will be needed for fields including power generation, resource mining, propellant production, construction, communication, and transportation.`,
          } as Section,
        ],
      } as MetricTile,
    } as SwiperTile,
    {
      type: "metrics",
      tile: {
        tilePosition: "inner-right-top",
        header: "Spaceports",
        sections: [
          {
            imageUrl: "assets/images/human-spaceflight/mars/mars_carousel2_card4_d.jpg",
            mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_carousel2_card4_m.jpg",
            description: `Established launch and landing sites will enable global mobility and return capability to Earth. Starship was designed from the beginning to run off of liquid methane and oxygen, natural resources that can be mined and refined on Mars.`,
          } as Section,
        ],
      } as MetricTile,
    } as SwiperTile,
  ],
} as SwiperData;

export const landingOnMarsTileData: VideoTile = {
  header: "Landing on Mars",
  description: `Starship will enter Mars' atmosphere at 7.5 kilometers per second and decelerate aerodynamically. The vehicle's heatshield is designed to withstand multiple entries, but given that the vehicle coming into Mars' atmosphere experiences higher levels of atomic oxygen, we expect to see harsher conditions during entry. The engineering video below shows actual Starship heatshield materials being tested in a simulated Mars atmosphere.`,
  imageUrl: "assets/images/human-spaceflight/mars/mars_feature2_d.jpg",
  mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_feature2_m.jpg",
  imageFullscreen: true,
  textPosition: "inner-left-bottom",
  buttonText: "Watch Video",
  videoType: "host",
  videoUrl: "https://content.spacex.com/cms-assets/assets/mars_plasmajet_testing.mp4",
} as VideoTile;

export const mars2026TileData: VideoTile = {
  header: "Making Life MultiPlanetary",
  description: `Starship is designed to fly to other worlds and will enable self-growing bases on the Moon, an entire civilization on Mars, and ultimately expansion to the Universe.`,
  imageUrl: "assets/images/human-spaceflight/mars/mars_feature1_d.jpg",
  mobileImageUrl: "assets/images/human-spaceflight/mars/mobile/mars_feature1_m.jpg",
  imageAriaLabel: `Play video about SpaceX's Mars 2026 Plan`,
  imageAltText: `SpaceX's Mars 2026 Plan`,
  imageFullscreen: true,
  textPosition: "inner-left-top",
  buttonText: "Watch Presentation",
  videoType: "x.com",
  videoUrl: "https://x.com/SpaceX/status/1928185351933239641",
} as VideoTile;

export const marsMissionsData: MetricTile = {
  header: "Mars Missions",
  tilePosition: "inner-left-top",
  sections: [
    {
      description: `Starship cargo flights to the Martian surface for research, development, and exploratory missions start no earlier than 2028, at a rate of $100 million per metric ton. `,
      secondDescription: `For additional information on payload masses, pricing details, and timeframes, please contact <a href="mailto:sales@spacex.com">sales@spacex.com</a>.`,
      imageUrl: "assets/images/vehicles/starship/starship_carousel2_card4_d.jpg",
      mobileImageUrl: "assets/images/vehicles/starship/mobile/starship_carousel2_card4_v2_m.jpg",
    } as Section,
  ],
} as MetricTile;

export const marsPageFooterData: PageFooterData = {
  caption: "For more information about crew and cargo missions to Earth orbit and beyond, contact ",
  captionEmail: "sales@spacex.com",
  buttons: [{ text: `Contact us`, url: `mailto:sales@spacex.com` } as PageFooterButton],
} as PageFooterData;

export const starshipTile: MetricTile = {
  header: "Starship",
  tilePosition: "inner-left-middle",
  buttonText: "Learn more about Starship",
  buttonUrl: "/vehicles/starship",
  videoUrl: "https://content.spacex.com/cms-assets/assets/V3_FS_WEB.mp4",
  mobileVideoUrl: "https://content.spacex.com/cms-assets/assets/V3_FS_MOBILE.mp4",
  sections: [
    {
      description: "SpaceX's Starship spacecraft and Super Heavy rocket - collectively referred to as Starship - represent a fully reusable transportation system designed to carry both crew and cargo to Earth orbit, the Moon, Mars and beyond. Starship is the world's most powerful launch vehicle ever developed, designed to carry more than 100 metric tonnes to orbit in a fully reusable configuration.",
    } as Section,
  ],
} as MetricTile;